"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SalesForceClientType = void 0;
var SalesForceClientType;
(function (SalesForceClientType) {
    SalesForceClientType["HerffJonesCollege"] = "HerffJonesCollege";
    SalesForceClientType["HerffJonesHighSchool"] = "HerffJonesHighSchool";
    SalesForceClientType["HerffJonesSchoolDistrict"] = "HerffJonesSchoolDistrict";
    SalesForceClientType["SingleInstitution"] = "SingleInstitution";
    SalesForceClientType["InstitutionGroup"] = "InstitutionGroup";
})(SalesForceClientType = exports.SalesForceClientType || (exports.SalesForceClientType = {}));
//# sourceMappingURL=salesforce.js.map